/* eslint-disable no-unused-vars */
import http from "../../BaseServiceHttp";
import { DateTime } from "luxon";
class GraphService {
  getGraphElements(productionUnitId, startTime, endTime, optionalProductionRunOptions) {
    const startParam = encodeURIComponent(startTime);
    const endParam = encodeURIComponent(endTime);
    const skuParam = optionalProductionRunOptions?.sku ? `&sku=${encodeURIComponent(optionalProductionRunOptions.sku)}` : "";
    const workOrderIdParam = optionalProductionRunOptions?.workOrderId ? `&work_order_id=${encodeURIComponent(optionalProductionRunOptions.workOrderId)}` : "";
    const lotIdParam = optionalProductionRunOptions?.lotId ? `&lot_id=${encodeURIComponent(optionalProductionRunOptions.lotId)}` : "";
    let url = `/production-units/${productionUnitId}/graph-elements?start_time=${startParam}&end_time=${endParam}${skuParam}${workOrderIdParam}${lotIdParam}`;
    if (skuParam.length > 0 || workOrderIdParam.length > 0 || lotIdParam.length > 0) {
      // Fetch metrics for a Production Run
      url = url + "&is_production_run=true";
    }
    return http.get(url);
  }

  getSpeedGraphElements(productionUnitId, startTime, endTime, optionalProductionRunOptions) {
    let timeAggregation = "5m";
    let startDateTime = DateTime.fromISO(startTime);
    let endDateTime = DateTime.fromISO(endTime);
    let diffInMinutes = endDateTime.diff(startDateTime, ["minutes"]).minutes;
    if (diffInMinutes <= 60) {
      timeAggregation = "1m";
    }
    const startParam = encodeURIComponent(startTime);
    const endParam = encodeURIComponent(endTime);
    const skuParam = optionalProductionRunOptions?.sku ? `&sku=${encodeURIComponent(optionalProductionRunOptions.sku)}` : "";
    const workOrderIdParam = optionalProductionRunOptions?.workOrderId ? `&work_order_id=${encodeURIComponent(optionalProductionRunOptions.workOrderId)}` : "";
    const lotIdParam = optionalProductionRunOptions?.lotId ? `&lot_id=${encodeURIComponent(optionalProductionRunOptions.lotId)}` : "";
    let url = `/production-units/${productionUnitId}/speed-graph-elements?start_time=${startParam}&end_time=${endParam}&interval_duration=${timeAggregation}${skuParam}${workOrderIdParam}${lotIdParam}`;
    if (skuParam.length > 0 || workOrderIdParam.length > 0 || lotIdParam.length > 0) {
      // Fetch metrics for a Production Run
      url = url + "&is_production_run=true";
    }
    return http.get(url);
  }

  getGiveawayElements(productionUnitId, startTime, endTime, chartType) {
    const startParam = encodeURIComponent(startTime);
    const endParam = encodeURIComponent(endTime);
    return http.get(`/production-units/${productionUnitId}/giveaway-spc?chart_type=${chartType}&start_time=${startParam}&end_time=${endParam}`);
  }
}

export default new GraphService();
